import cookie from 'cookie';
import get from 'lodash.get';

export const EU_SITE_COOKIE_NAME = 'eu-site';

export const onAdsContextChange = (gaiaId) => {
    if (gaiaId) {
        window.meso.targeting.push({adinfo: {dest: gaiaId}});
    }
};

export const onAdsContextInit = ({brandId, locale, havId, gaiaId}) => {
    window.meso = window.meso || {};
    window.meso.logging = window.meso.logging || [];
    window.meso.targeting = window.meso.targeting || [];
    window.meso.initialize = window.meso.initialize || [];

    const isEU = cookie.parse(document.cookie)[EU_SITE_COOKIE_NAME] === '1';
    const gdpr = get(window, 'cookieconsent.gdpr', null);
    const pageId = get(window, 'analyticsdatalayer.pagetype', 'search');

    if (window.meso.logging.length === 0) {
        window.meso.logging.push(`Adblock: ${window.adblock}`);
    }

    document.cookie = cookie.serialize('DUAID', havId);

    window.meso.initialize.push({
        pageId,
        type: 'target',
        siteId: brandId,
        variant: 'default',
        locale: locale && locale.replace('-', '_'),
        canTrack: isEU ? (gdpr && gdpr.hasConsented()) : true
    });

    onAdsContextChange(gaiaId);
};
